import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent implements OnInit {
  @Input() offer;
  @Output() onOfferStatus: EventEmitter<any> = new EventEmitter<any>();
  selectedSubjects = [];
  totalESPB = 0;
  constructor(private fsFunc: AngularFireFunctions) { }

  ngOnInit(): void {
    console.log(this.offer)
    this.selectedSubjects = this.offer.availableSubjects;
    this.calculateTotal();
  }
  calculateTotal() {
    this.totalESPB = 0;
    this.selectedSubjects.forEach(s => {
      this.totalESPB += parseInt(s.subjectFON.espb);
    })
  }
  acceptOffer() {
    this.onOfferStatus.emit("ACCEPTED")
    this.fsFunc.httpsCallable('sendOrderRecievedEmail')({
      order_id: this.offer.order_id
    })
      .subscribe(res => {
        console.log(res);
      })
  }
  refuseOffer() {
    this.onOfferStatus.emit("REFUSED")
    this.fsFunc.httpsCallable('sendOrderRecievedEmail')({
      order_id: this.offer.order_id
    })
      .subscribe(res => {
        console.log(res);
      })
  }

}
